import { Button, Col, DatePicker, Input, Row, Select } from "antd"
import { CSSProperties } from "react"
const styleModel : CSSProperties = {
  display:'flex',
  justifyItems:'center',
  alignItems:'center'
}
interface FileItemSearchViewProps{
  fileName?:string
  setFileName:(v:string)=>void
  fileUnit?:string
  setFileUnit:(v:string)=>void
  fileCode?:string
  setFileCode:(v:string)=>void
  fileTime?:string
  setFileTime:(v:string)=>void
  fileTimeDate?:any
  setFileTimeDate:(v:any)=>void
  isAbolish?:string
  setIsAbolish:(v:string)=>void
  searchLoading:boolean
  setSearchLoading:(v:boolean)=>void
  clear:()=>void
  searchFile:(page:number)=>void
}

export default(p:FileItemSearchViewProps)=>{
  // 文件名，发文单位，编号，发文时间，是否废止
  const {fileName,setFileName} = p
  const {fileUnit,setFileUnit} = p
  const {fileCode,setFileCode} = p
  const {fileTime,setFileTime} = p
  const {fileTimeDate,setFileTimeDate} = p
  const {isAbolish,setIsAbolish} = p
  const {searchLoading,setSearchLoading} = p
  const {clear,searchFile} = p

  return(
    <div style={{paddingBottom:'15px',paddingLeft:'15px',paddingRight:'15px'}}>
      <Row gutter={[30, 10]}>
        <Col  span={8}>
          <div style={styleModel}>
            文&ensp;件&ensp;名：<Input style={{flex:1}} placeholder="请输入" value={fileName} onChange={(e)=>setFileName(e.target.value)}/>
          </div>
        </Col>
        <Col  span={8}>
          <div style={styleModel}>
            发文单位：<Input style={{flex:1}} value={fileUnit} placeholder="请输入" onChange={(e)=>setFileUnit(e.target.value)}/>
          </div>
        </Col>
        <Col  span={8}>
          <div style={styleModel}>
            编&emsp;&emsp;号：<Input style={{flex:1}} placeholder="请输入" value={fileCode} onChange={(e)=>setFileCode(e.target.value)}/>
          </div>
        </Col>
        <Col  span={8}>
          <div style={styleModel}>
            发文或实施时间：<DatePicker 
                        style={{flex:1}} 
                        placeholder="请选择"
                        value={fileTimeDate}
                        onChange={(value,dateString)=>{
                          console.log('value = ',value)
                          console.log('dateString = ',dateString)
                          setFileTime(dateString)
                          setFileTimeDate(value)
                        }} />
          </div>
        </Col>
        <Col  span={8}>
          <div style={styleModel}>
            是否废止：<Select
                        style={{flex:1}}
                        value={isAbolish}
                        placeholder={'请选择'}
                        onChange={(value)=>setIsAbolish(value)}
                        options={[
                          { value: '是', label: '是' },
                          { value: '否', label: '否' },
                        ]}
                      />
          </div>
        </Col>
        <Col  span={8}>
            <div style={{display:'flex',justifyContent:'flex-end',justifyItems:'flex-end'}}>
              <Button type="primary" onClick={()=>{
                clear()
              }}>重置</Button>
              <Button type="primary" style={{marginLeft:'10px'}} loading={searchLoading} onClick={()=>searchFile(1)}>
                查询
              </Button>
            </div>
            
        </Col>
        </Row>
    </div>
  )
}

export type {}